<interview-wrapper [title]="'interviews.Settings Heading' | translate">
    <div step-content>
        <ol class="ordered-list">
            <li class="list-item">
                {{'interviews.Select Inputs' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Settings Instructions 1' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Settings Instructions 2' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Settings Instructions 3' | translate}}
            </li>
        </ol>
        <div class="video-settings">
            <div class="input-wrapper">
                <label for="videoSource">{{'interviews.Video Input' | translate}}</label>
                <select name="video-source" id="videoSource"></select>
            </div>
            <div class="input-wrapper">
                <label for="audioSource">{{'interviews.Audio Input' | translate}}</label>
                <select name="audio-source" id="audioSource"></select>
            </div>
            <div class="input-wrapper volume-meter">
                <label for="meterGraph">{{'interviews.Volume Level' | translate}}</label>
                <div id="meterGraph">
                    <div id="meter"></div>
                </div>
                <div class="opt-level">
                    <span class="opt-level-icon"></span>
                    <span class="opt-level-label">{{'interviews.Optimum' | translate}}</span>
                    <span class="opt-level-icon"></span>
                </div>
            </div>
            <div class="video-container video">
                <video-stream></video-stream>
            </div>
        </div>
    </div>
  
    <div step-actions>
        <button type="button" [routerLink]="['../response']" [disabled]="!stream" class="btn btn_secondary">
            {{'interviews.Practice Question' | translate}}
        </button>
        <button type="button" [routerLink]="['../begin']" [disabled]="!stream" class="btn btn_primary">
            {{'interviews.Begin Interview' | translate}}
        </button>
    </div>
</interview-wrapper>
